/**
 * Мок журнала платежей (числа синхронны дизайну Payments). Сводка — итоги
 * за период (не сумма видимых строк). Когда подключим BE — заменит
 * `GET /admin/payments` (ADMIN_BACKEND §6).
 */

import type {PaymentRow, PaymentsSummary} from './types';

export const PAYMENTS_SUMMARY: PaymentsSummary = {
  periodLabel: 'Июль 2026',
  successSum: 1_284_000,
  successCount: 128,
  failedCount: 9,
  failedSum: 41_000,
  refundSum: -12_000,
  refundCount: 2,
  net: 1_272_000,
};

export const PAYMENTS_TOTAL = 139;

export const MOCK_PAYMENTS: PaymentRow[] = [
  {
    id: 'p1',
    date: '2026-07-03',
    client: 'Ак-Тиш',
    clientType: 'clinic',
    type: 'Продление',
    period: 'Июль 2026',
    amount: 690_000,
    status: 'success',
    method: 'Карта •••• 4471',
    txnId: 'TXN-40912',
  },
  {
    id: 'p2',
    date: '2026-07-03',
    client: 'Медстом Центр',
    clientType: 'clinic',
    type: 'Продление',
    period: 'Июль 2026',
    amount: 812_000,
    status: 'success',
    method: 'Карта •••• 2038',
    txnId: 'TXN-40908',
  },
  {
    id: 'p3',
    date: '2026-07-02',
    client: 'Асанов Бакыт',
    clientType: 'solo',
    type: 'Активация',
    period: 'Июль 2026',
    amount: 1_200,
    status: 'success',
    method: 'Карта •••• 7712',
    txnId: 'TXN-40903',
  },
  {
    id: 'p4',
    date: '2026-07-02',
    client: 'Смайл Студия',
    clientType: 'clinic',
    type: 'Продление',
    period: 'Июль 2026',
    amount: 165_000,
    status: 'failed',
    method: 'Карта •••• 1190',
    txnId: 'TXN-40901',
  },
  {
    id: 'p5',
    date: '2026-07-01',
    client: 'Ортодонт Люкс',
    clientType: 'clinic',
    type: 'Продление',
    period: 'Июль 2026',
    amount: 430_000,
    status: 'success',
    method: 'Карта •••• 5521',
    txnId: 'TXN-40890',
  },
  {
    id: 'p6',
    date: '2026-07-01',
    client: 'Дент-Арт',
    clientType: 'clinic',
    type: 'Возврат',
    period: 'Июнь 2026',
    amount: -98_000,
    status: 'refund',
    method: 'Карта •••• 3140',
    txnId: 'TXN-40771',
  },
  {
    id: 'p7',
    date: '2026-06-30',
    client: 'Мамытов Эрлан',
    clientType: 'solo',
    type: 'Ручная оплата',
    period: 'Июль 2026',
    amount: 51_000,
    status: 'success',
    method: 'Карта •••• 8830',
    txnId: 'TXN-40765',
  },
  {
    id: 'p8',
    date: '2026-06-30',
    client: 'Керимова Нургуль',
    clientType: 'solo',
    type: 'Активация',
    period: 'Июль 2026',
    amount: 1_200,
    status: 'success',
    method: 'Карта •••• 9004',
    txnId: 'TXN-40760',
  },
  {
    id: 'p9',
    date: '2026-06-29',
    client: 'Дентал Плюс',
    clientType: 'clinic',
    type: 'Продление',
    period: 'Июль 2026',
    amount: 312_000,
    status: 'success',
    method: 'Карта •••• 6647',
    txnId: 'TXN-40742',
  },
];
